var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import { define, Model, type } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { ActivityLogCard } from "./activityLogCard";
var ActivityLogList = /** @class */ (function (_super) {
    __extends(ActivityLogList, _super);
    function ActivityLogList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActivityLogList.endpoint = restfulIO('/api/v1/assetmaster/AssetsEvents/logs');
    ActivityLogList.attributes = {
        activeLogList: type([ActivityLogCard]).endpoint(restfulIO('./')).dontSave,
    };
    ActivityLogList = __decorate([
        define
    ], ActivityLogList);
    return ActivityLogList;
}(Model));
export { ActivityLogList };
//# sourceMappingURL=activityLogList.js.map